export const colors = {
  primary: '#3aa4c6',
  primaryLight: 'rgba(58, 164, 198, 0.1)',
  primaryDark: '#2a7b96',
  secondary: '#2C3E50',
  textDark: '#2c3e50',
  textLight: '#5a6c7d',
  background: '#ffffff',
  backgroundLight: '#f8f9fa',
  backgroundGradient: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
  success: '#2ecc71',
  error: '#e74c3c',
  white: '#ffffff',
  black: '#000000',
  border: '#e9ecef',
  shadow: 'rgba(58, 164, 198, 0.1)',
  overlay: 'rgba(0, 0, 0, 0.5)',
  // Additional colors for the new palette
  primaryLighter: '#4fb8d9',
  primaryDarker: '#1f5c70',
  accentLight: '#e3f4f9',
  accent: '#8fd3e8',
  accentDark: '#5c9fb3'
};
